import { spring } from 'motion';
import { JSX } from 'solid-js';

import { noop } from './listTransition';

export function animate(
  el: Element,
  options: AnimateOptions,
  counterpart: AnimateReturn | undefined,
  t2: 0 | 1,
  onFinish?: () => void
): AnimateReturn {
  const isIntro = t2 === 1;

  let t = () => 1 - t2;
  counterpart?.deactivate();
  const css = options.css;
  const delay = options.delay;
  const keyframes = [];
  if (isIntro && counterpart === void 0) {
    if (css) {
      var styles = css(0);
      keyframes.push(styles, styles);
    }
  }

  let animation = el.animate(keyframes, { duration: delay || 0 });
  animation.onfinish = () => {
    const t1 = counterpart?.t ?? 1 - t2;
    counterpart?.abort();
    const delta = t2 - t1;
    const duration = (options.duration ?? 350) * Math.abs(delta);
    let easing = options.easing;
    if (!easing) {
      const springEasing = spring({ keyframes: [0, 1], duration, bounce: 0 });
      easing = (t) => springEasing.next(t * duration).value;
    }

    const keyframes: Style[] = [];
    var n = Math.ceil(duration / (1e3 / 60));
    for (var i = 0; i <= n; i += 1) {
      let t = t1 + delta * easing(i / n);
      let styles2 = css(t);
      keyframes.push(styles2);
    }

    animation = el.animate(keyframes, { duration });

    t = () => {
      const time = Number(animation.currentTime);
      return t1 + delta * easing(time / duration);
    };
    animation.finished
      .then(
        () => {
          t = () => t2;
          onFinish?.();
        },
        () => {}
      )
      .finally(abort);
  };

  let abort = () => {
    abort = noop;
    animation.cancel();
    animation.effect = null;
  };

  const ane: AnimateReturn = {
    animation,
    deactivate() {
      onFinish = noop;
    },
    abort() {
      return abort();
    },
    get t() {
      return t();
    },
  };

  return ane;
  // const ane = animate(el, keyframes, {...animateOptions, ...options});
  // if (onFinish) {
  //   ane.duration > 0 ? ane.then(() => {
  //     ane.cancel();
  //   }).catch(noop) : onFinish();
  // }
  // return ane;
}

export interface AnimateReturn {
  animation: Animation;
  deactivate(): void;
  abort: () => void;
  get t(): number;
}

export interface AnimateOptions {
  easing?(t: number): number;
  delay?: number;
  duration?: number;
  css(t: number): Style;
}

export type Style = Omit<JSX.CSSProperties, 'offset'>;
